import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  DateRangePicker,
  createStaticRanges,
} from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import {
  subDays,
  addDays,
  endOfDay,
  startOfDay,
  startOfMonth,
  endOfMonth,
  addMonths,
  startOfWeek,
  endOfWeek,
  intervalToDuration,
  format,
  differenceInDays
} from "date-fns";
import { Button, Dropdown, Form } from "react-bootstrap";
import "./index.css";

const INTERVAL_OPTIONS = [
  { value: "day", label: "By Day" },
  { value: "week", label: "By Week" },
  { value: "month", label: "By Month" },
];
const CustomDateRangeFilter = ({ onChange, isByInterval }) => {
  const [showDateRange, setShowDateRange] = useState(false);
  const [isCompactPicker, setIsCompactPicker] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );
  const startDate = useSelector((state) => state?.globalFilters?.startDate);
  const endDate = useSelector((state) => state?.globalFilters?.endDate);
  const rangeInterval = useSelector((state) => state?.globalFilters?.interval);
  // const [startDate, setStartDate] = useState(subDays(new Date(), 6));
  // const [endDate, setEndDate] = useState(endOfDay(new Date()));
  const [interval, setInterval] = useState("week");
  const defineds = {
    startOfWeek: startOfWeek(new Date()),
    endOfWeek: endOfWeek(new Date()),
    startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
    endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
    startOfToday: startOfDay(new Date()),
    endOfToday: endOfDay(new Date()),
    startOfYesterday: startOfDay(addDays(new Date(), -1)),
    endOfYesterday: endOfDay(addDays(new Date(), -1)),
    startOfMonth: startOfMonth(new Date()),
    endOfMonth: endOfMonth(new Date()),
    startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
    endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
  };

  const getInterval = (startDate, endDate) => {
    const temp = intervalToDuration({
      start: startDate,
      end: endDate,
    });
    let interval = "";
    if (temp.days <= 7 && temp.months === 0) {
      interval = "day";
    } else if (temp.days > 7 && temp.months === 0) {
      interval = "week";
    } else {
      interval = "month";
    }
    return interval;
  };
  const customDefaultStaticRanges = createStaticRanges([
    {
      label: "Last 7 Days",
      range: () => ({
        startDate: subDays(new Date(), 6),
        endDate: defineds.endOfToday,
        label: "Last 7 Days",
        customKey: 'last7Days',
      }),
    },
    {
      label: "Last 21 Days",
      range: () => ({
        startDate: subDays(new Date(), 20),
        endDate: defineds.endOfToday,
        label: "Last 21 Days",
        customKey: 'last21Days',
      }),
    },
    {
      label: "Last 30 Days",
      range: () => ({
        startDate: subDays(new Date(), 29),
        endDate: defineds.endOfToday,
        label: "Last 30 Days",
        customKey: 'last30Days',
      }),
    },
    {
      label: "Last 60 Days",
      range: () => ({
        startDate: subDays(new Date(), 59),
        endDate: defineds.endOfToday,
        label: "Last 60 Days",
        customKey: 'last60Days',
      }),
    },
    {
      label: "Last 90 Days",
      range: () => ({
        startDate: subDays(new Date(), 89),
        endDate: defineds.endOfToday,
        label: "Last 90 Days",
        customKey: 'last90Days',
      }),
    },
    {
      label: "Last 120 Days",
      range: () => ({
        startDate: subDays(new Date(), 119),
        endDate: defineds.endOfToday,
        label: "Last 120 Days",
        customKey: 'last120Days',
      }),
    },
    {
      label: "Custom Period",
      range: () => ({
        startDate: state[0]?.customKey === 'customPeriod' ? state[0].startDate : subDays(new Date(), 1),
        endDate: state[0].endDate,
        label: "Custom Period",
        customKey: 'customPeriod',
      }),
    },
  ]);
  const [state, setState] = useState([
    {
      startDate: startDate,
      endDate: endDate,
      key: "selection",
      label: rangeInterval,
    },
  ]);
  useEffect(() => {
    const handleResize = () => {
      setIsCompactPicker(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const temp = getInterval(state[0].startDate, state[0].endDate);
    onChange(state[0], temp);
  }, []);
  useEffect(() => {
    const temp = getInterval(state[0].startDate, state[0].endDate);

    setInterval(temp);
  }, [state]);
  const handleOnChange = (ranges) => {
    const { selection } = ranges;
    if (selection?.customKey === 'customPeriod' && state[0]?.customKey !== 'customPeriod') {
      selection.startDate = subDays(new Date(), 0);
      selection.endDate = defineds.endOfToday;
    } else if (!selection?.customKey) {
      selection.label = "Custom Period";
      selection.customKey = 'customPeriod';
    } else if (format(selection.startDate, "MM/dd/yyyy") === format(subDays(new Date(), 6), "MM/dd/yyyy") && differenceInDays(selection.endDate, selection.startDate) === 6) {
      selection.label = "Last 7 Days";
      selection.customKey = 'last7Days';
    } else if (format(selection.startDate, "MM/dd/yyyy") === format(subDays(new Date(), 20), "MM/dd/yyyy") && differenceInDays(selection.endDate, selection.startDate) === 20) {
      selection.label = "Last 21 Days";
      selection.customKey = 'last21Days';
    } else if (format(selection.startDate, "MM/dd/yyyy") === format(subDays(new Date(), 29), "MM/dd/yyyy") && differenceInDays(selection.endDate, selection.startDate) === 29) {
      selection.label = "Last 30 Days";
      selection.customKey = 'last30Days';
    } else if (format(selection.startDate, "MM/dd/yyyy") === format(subDays(new Date(), 59), "MM/dd/yyyy") && differenceInDays(selection.endDate, selection.startDate) === 59) {
      selection.label = "Last 60 Days";
      selection.customKey = 'last60Days';
    } else if (format(selection.startDate, "MM/dd/yyyy") === format(subDays(new Date(), 89), "MM/dd/yyyy") && differenceInDays(selection.endDate, selection.startDate) === 89) {
      selection.label = "Last 90 Days";
      selection.customKey = 'last90Days';
    } else if (format(selection.startDate, "MM/dd/yyyy") === format(subDays(new Date(), 119), "MM/dd/yyyy") && differenceInDays(selection.endDate, selection.startDate) === 119) {
      selection.label = "Last 120 Days";
      selection.customKey = 'last120Days';
    } else {
      selection.label = "Custom Period";
      selection.customKey = 'customPeriod';
    }


    // console.log('ranges', ranges);
    // onChange(selection);
    //setStartDate(selection.startDate);
    //setEndDate(selection.endDate);
    setState([selection]);
    //setShowDateRange(!showDateRange);
  };
  const DateContainer = ({ data }) => {
    return <span>{format(data, "MM/dd/yyyy")}</span>;
  };
  const ApplyButton = () => {
    return (
      <div className="date-range-picker-action-container">
        <Button
          //className="btn btn-transparent text-primary rounded-0 px-4 mr-2"
          onClick={() => { onChange(state[0], interval); setShowDateRange(!showDateRange) }}
        >
          Apply
        </Button>
      </div>
    );
  };

  const handleInterval = (value) => {
    setInterval(value);
    if (!showDateRange) {
      onChange(state[0], value);
    }
  };
  const selectedInterval =
    INTERVAL_OPTIONS.find((option) => option.value === interval)?.label ||
    "Select Interval";
  return (
    <div className="custom-date-range-filter">
      <div className="custom-date-range-filter-bar">
        <Button
          className="date-range-action"
          onClick={() => {
            setShowDateRange(true);
          }}
          variant="outline-primary"
        >
          {!!state[0]?.label ? state[0]?.label : "Last 30 days"}
        </Button>
        <div className="date-container">
          <div className="date-row start-date-container">
            <span className="date-label">Start Date:</span>
            <DateContainer data={state[0]?.startDate} />
          </div>
          <div className="date-row end-date-container">
            <span className="date-label">End Date:</span>
            <DateContainer data={state[0]?.endDate} />
          </div>
        </div>
        {!!isByInterval && (
          <div className="date-interval-control">
            <Form.Label className="date-interval-label">Interval</Form.Label>
            <Dropdown
              className="date-interval-dropdown"
              onSelect={(key) => handleInterval(key)}
            >
              <Dropdown.Toggle
                variant="light"
                className="date-interval-select-toggle"
                aria-label="Select interval"
              >
                {selectedInterval}
              </Dropdown.Toggle>
              <Dropdown.Menu align="start" className="date-interval-select-menu">
                {INTERVAL_OPTIONS.map((option) => (
                  <Dropdown.Item
                    key={option.value}
                    eventKey={option.value}
                    active={option.value === interval}
                  >
                    {option.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
      </div>
      {!!showDateRange && (
        <>
          <div
            className="date-range-picker-overlay"
            onClick={() => setShowDateRange(false)}
            aria-hidden="true"
          />
          <div className="date-range-picker-custom-container">
            <DateRangePicker
              onChange={handleOnChange}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={true}
              months={isCompactPicker ? 1 : 2}
              ranges={state}
              direction={isCompactPicker ? "vertical" : "horizontal"}
              staticRanges={customDefaultStaticRanges}
              inputRanges={[]}
              footerContent={<ApplyButton />}
              maxDate={defineds.startOfToday}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default CustomDateRangeFilter;
